import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const editPerson = async ({
	id,
	payload
}: {
	id: string;
	payload: Record<string, unknown>;
}) => {
	const response = await cmsClient.patch<IRetailUser>(
		`/homepage/admin/store/user/${id}/`,
		payload
	);

	return response.data;
};

const useEditPerson = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(<CustomToast type="Success" message="Person updated" />, {
			hideProgressBar: true
		});
	};

	const onSettled = (
		_data: unknown,
		_error: unknown,
		variables: { id: string; payload: Record<string, unknown> }
	) => {
		queryClient.invalidateQueries(["admin-people"]);
		queryClient.invalidateQueries(["admin-person", variables.id]);
		queryClient.invalidateQueries(["person-profile", variables.id]);
	};

	const onError = (error: unknown) => {
		const detail = (error as { response?: { data?: Record<string, unknown> } })
			?.response?.data;
		const message =
			(detail as { detail?: string })?.detail ??
			(detail ? Object.values(detail).flat().join(" ") : undefined) ??
			"Something went wrong, try again";

		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const mutation = useMutation(editPerson, {
		onError,
		onSuccess,
		onSettled
	});

	return mutation;
};

export default useEditPerson;
